/**
 * The undo stack of the object session: one `{ undo() }` closure per user
 * change (a drawn, moved, reshaped, relabelled or removed box). The most recent
 * change comes off first. It is cleared when the open tile changes or the
 * session ends, so an undo never reaches into another tile.
 */
export const MAX_HISTORY = 20;

let stack = [];

/** Remember a change; the oldest one is dropped past the cap. */
export const pushHistory = entry => {
	if (typeof entry?.undo !== 'function') return;
	stack.push(entry);
	if (stack.length > MAX_HISTORY) stack.shift();
};

/** Revert the most recent change. Returns false when there is none. */
export const undoLast = () => {
	const entry = stack.pop();
	if (!entry) return false;
	entry.undo();
	return true;
};

export const clearHistory = () => {
	stack = [];
};

export const historySize = () => stack.length;
